<template>
  <vistor-table
    title="今日访客"
    :iconImg="require('@/assets/vistor/today.png')"
    rightNum="100"
  >
    <div class="today-vistor">
      <div class="today-table">
        <auto-table :header="header" :tableData="tableData"></auto-table>
      </div>
      <div class="minor-img"></div>
    </div>
  </vistor-table>
</template>

<script>
export default {
  data() {
    return {
      header: [
        {
          name: "拜访时间",
          key: "dayTime",
          width: "160",
          align: "center",
        },
        {
          name: "访客信息",
          key: "dayInfo",
          width: "136",
          align: "center",
        },
        {
          name: "拜访地址",
          key: "dayArea",
          width: "80",
          align: "center",
        },
      ],
      tableData: [
        {
          dayTime: "2022-03-13 08:32:56",
          dayInfo: "15912341572",
          dayArea: "A013",
        },
        {
          dayTime: "2022-03-13 08:32:56",
          dayInfo: "15912341572",
          dayArea: "A013",
        },
        {
          dayTime: "2022-03-13 08:32:56",
          dayInfo: "15912341572",
          dayArea: "A013",
        },
      ],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    getTel(tel) {
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      return tel.replace(reg, "$1****$2");
    },
    initData() {
      this.tableData.map((item, index) => {
        item.dayInfo = this.getTel(item.dayInfo);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.today-vistor {
  width: 100%;
  pointer-events: all;
  padding: 20px 20px;
  .today-table {
    width: 100%;
    height: 128px;
  }
  .minor-img {
    margin-top: 10px;
    margin-left: -20px;
    width: 417px;
    height: 233px;
    background-image: url("../../../../../assets/vistor/black-bg.png");
    background-size: cover;
  }
}
</style>
